










import { Vue, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Banner from '@/components/Banner.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { getBaseinfo } from '@/api/api';
import { Popup } from 'vant';
Vue.use(Popup);
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  option = config.OPTHINES;
  bannerSrc = '';
  activityId = 0;
  async created() {
    const res = await getBaseinfo(this.option.voteName);
    this.bannerSrc = res.data.banner;
    this.activityId = res.data.activityId;
    // 分享
    this.$appShareInfo({
      title: '2019年度科技互联网行业飙榜评选',
      url: window.location.href,
      subtitle: '2019年度科技互联网行业飙榜评选',
      classId: -1,
      id: -1,
      image: this.bannerSrc,
      type: 3,
    });
    this.$wxShareInfo({
      title: '2019年度科技互联网行业飙榜评选',
      subtitle: '2019年度科技互联网行业飙榜评选',
      image: this.bannerSrc,
    });
    this.$addPv(this.activityId);
  }
}
